import Router from './Router.js'

import './style/index.styl'

// react-scripts 4.x 自带 Fast Refresh 功能。不在需要 react-hot-loader
export default Router
